import { render, staticRenderFns } from "./bottom_h5.vue?vue&type=template&id=f18932e4&scoped=true"
import script from "./bottom_h5.vue?vue&type=script&lang=js"
export * from "./bottom_h5.vue?vue&type=script&lang=js"
import style0 from "./bottom_h5.vue?vue&type=style&index=0&id=f18932e4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f18932e4",
  null
  
)

export default component.exports